import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from '../../index';
import { tokenRequest } from '../AuthConfig';
import type { AuthAccount, AuthClient } from './authClient';

/**
 * B2C through MSAL - the existing behaviour, moved behind {@link AuthClient}. `msalInstance` is read
 * inside each method, never captured: `src/index` creates it after this module has been loaded.
 */
export class MsalAuthClient implements AuthClient {
  async initialize(): Promise<boolean> {
    await msalInstance.initialize();
    // MSAL raises LOGIN_SUCCESS itself; index.tsx subscribes to it.
    return false;
  }

  getAccount(): AuthAccount | null {
    const account = msalInstance?.getAllAccounts()[0];
    return account ? { email: account.username } : null;
  }

  getAccessToken(options?: { forceRefresh?: boolean }): Promise<string> {
    const account = msalInstance.getAllAccounts()[0];
    return msalInstance
      .acquireTokenSilent({
        ...tokenRequest,
        account,
        forceRefresh: options?.forceRefresh === true,
      })
      .then((result) => result.accessToken);
  }

  /** Re-authenticates the cached account (used when a session dies mid-use). */
  async loginRedirect(): Promise<void> {
    if (!msalInstance) return;
    const account = msalInstance.getAllAccounts()[0];
    await msalInstance.acquireTokenRedirect({ ...tokenRequest, account });
  }

  logout(): Promise<void> {
    return msalInstance.logoutRedirect();
  }

  isInteractionRequired(error: unknown): boolean {
    return error instanceof InteractionRequiredAuthError;
  }
}
